var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.state == "fetching"
        ? _c("div", { attrs: { id: "sending" } }, [
            _c("div", { staticClass: "overlay" }),
            _vm._v(" "),
            _c("div", { staticClass: "form-sending" }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "gigs",
            adaptive: true,
            scrollable: true,
            reset: true,
            width: "90%",
            maxWidth: 1100,
            height: "auto",
          },
        },
        [
          _c("div", { staticClass: "modal__content" }, [
            _c("div", { staticClass: "modal__header container" }, [
              _vm._v(
                "\n                Keikat - " +
                  _vm._s(_vm.bandName) +
                  "\n            "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "gigs-list container" },
              [
                _c("h3", [
                  _vm._v("Tulevat (" + _vm._s(_vm.upcoming.length) + ")"),
                ]),
                _vm._v(" "),
                _vm._l(_vm.upcoming, function (gig) {
                  return _c(
                    "div",
                    { key: gig.id, staticClass: "row gigs-list__row" },
                    [
                      _c("div", { staticClass: "col-md-2 gigs-list__item" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.eventDate(gig.dateandtime.date)) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-5 gigs-list__item" }, [
                        gig.venueName
                          ? _c("span", [_vm._v(_vm._s(gig.venueName))])
                          : _c("span", [_vm._v("Yksityistilaisuus")]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-5 gigs-list__item" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(gig.city.cityName) +
                            "\n                    "
                        ),
                      ]),
                    ]
                  )
                }),
                _vm._v(" "),
                _c("h3", [
                  _vm._v("Vedetyt (" + _vm._s(_vm.passed.length) + ")"),
                ]),
                _vm._v(" "),
                _vm._l(_vm.passed, function (gig) {
                  return _c(
                    "div",
                    { key: gig.id, staticClass: "row gigs-list__row" },
                    [
                      _c("div", { staticClass: "col-md-2 gigs-list__item" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.eventDate(gig.dateandtime.date)) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-5 gigs-list__item" }, [
                        gig.venueName
                          ? _c("span", [_vm._v(_vm._s(gig.venueName))])
                          : _c("span", [_vm._v("Yksityistilaisuus")]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-5 gigs-list__item" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(gig.city.cityName) +
                            "\n                    "
                        ),
                      ]),
                    ]
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "modal__footer" }, [
              _c(
                "span",
                {
                  staticClass: "btn btn--hollow btn--small btn--call-to-action",
                  on: { click: _vm.closeModal },
                },
                [_vm._v("Sulje")]
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", [
        _c(
          "a",
          { staticClass: "btn--show-all-gigs", on: { click: _vm.openModal } },
          [_vm._v("Näytä kaikki keikat")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }